import { render, staticRenderFns } from "./_form.vue?vue&type=template&id=369a2fc5&scoped=true&"
import script from "./_form.vue?vue&type=script&lang=ts&"
export * from "./_form.vue?vue&type=script&lang=ts&"
import style0 from "./_form.vue?vue&type=style&index=0&id=369a2fc5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a2fc5",
  null
  
)

export default component.exports